export const getAllLatePolicyConfigurations = `
query {
  allLatePolicyConfigurations {
    id
    name
    employeeType
    category
    isActive
    otLateDeductionMode
    slabs {
      id
      slabType
      fromMinutes
      toMinutes
      action
      lopDays
    }
  }
}`;

export const getLatePolicyConfigurationById = `
query($id: ID!) {
  latePolicyConfigurationById(id: $id) {
    id
    name
    employeeType
    category
    isActive
    otLateDeductionMode
    slabs {
      id
      slabType
      fromMinutes
      toMinutes
      action
      lopDays
    }
  }
}`;

export const createLatePolicyConfigurationMutation = `
mutation CreateLatePolicyConfiguration(
  $name: String!
  $employeeType: String
  $category: String
  $isActive: Boolean
  $otLateDeductionMode: String
  $slabs: [LatePolicySlabInput]
) {
  createLatePolicyConfiguration(
    name: $name
    employeeType: $employeeType
    category: $category
    isActive: $isActive
    otLateDeductionMode: $otLateDeductionMode
    slabs: $slabs
  ) {
    success
    message
    latePolicyConfiguration {
      id
      name
    }
  }
}`;

export const updateLatePolicyConfigurationMutation = `
mutation UpdateLatePolicyConfiguration(
  $id: ID!
  $name: String
  $employeeType: String
  $category: String
  $isActive: Boolean
  $otLateDeductionMode: String
  $slabs: [LatePolicySlabInput]
) {
  updateLatePolicyConfiguration(
    id: $id
    name: $name
    employeeType: $employeeType
    category: $category
    isActive: $isActive
    otLateDeductionMode: $otLateDeductionMode
    slabs: $slabs
  ) {
    success
    message
    latePolicyConfiguration {
      id
      name
    }
  }
}`;

export const deleteLatePolicyConfigurationMutation = `
mutation DeleteLatePolicyConfiguration($id: ID!) {
  deleteLatePolicyConfiguration(id: $id) {
    success
    message
  }
}`;

export const employeeTypeOptionapi = `
query {
  allEmployeeTypes {
    id
    employeetype
  }
}`;

export const allCategoriesQuery = `
query {
  allCategories
}`;
